import { ChannelInterface } from "../interfaces/Channel.interface";
import { ChannelType } from "../flatbuffers/generated/archive/channel-type";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_CHANNEL: ChannelInterface = {
  id: null,
  serverId: null,
  organizationId: null,
  leadingZeroesId: null,
  name: "",
  type: ChannelType.ADAPTER,
  connectionType: ChannelType.TCP,
  index: "1",
  active: true,
  routable: false,
  baudRate: 1,
  heartbeatFrequency: 1,
  heartbeatMessage: null,
  vendorSocketAddress: "",
  routableSocketAddress: "",
  reportingSocketAddress: "",
  opcUaEndpointUrl: null,
  mtlsEnabled: false,
  mtlsSecretName: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
};
